/**
 * Redirects when a PoR page is hidden by workspace settings.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePorPageVisibility } from '../../hooks/usePorPageVisibility';
import { usePlanInstrumentNav } from '../../contexts/PlanInstrumentNavContext';
import type { PorPageKey } from '../../lib/porPageSettingsService';

export function PorVisiblePage({
  porId,
  pageKey,
  children,
}: {
  porId: string;
  pageKey: PorPageKey;
  children: ReactNode;
}) {
  const { porHref } = usePlanInstrumentNav();
  const { loading, isVisible, defaultLandingSegment } = usePorPageVisibility(porId);

  if (loading) {
    return (
      <div className="border border-[var(--rule)] dark:border-[var(--rule)] bg-[var(--bg-raised)] dark:bg-[var(--bg-raised)] px-6 py-12 text-center">
        <p className="text-sm text-[var(--text-ter)] dark:text-[var(--text-sec)]">Loading…</p>
      </div>
    );
  }

  if (!isVisible(pageKey)) {
    return <Navigate to={porHref(porId, defaultLandingSegment)} replace />;
  }

  return <>{children}</>;
}
